// @flow
/* eslint-disable no-irregular-whitespace */
import React from 'react';
import { connect } from 'react-redux';

import { updatePairs as updateUIPairs } from '../../redux/ui';

const Content = ({ modalType }: { modalType: string }) => {
  let title = '加盟店規約';
  let content = '';

  switch (modalType) {
    case 'merchant': {
      title = '加盟店規約';
      content = (
        <>
          <p>
            申込者（以下「甲」といいます。)
            は、甲が顧客に対して行う商品及び権利の販売並びに役務の提供に関し、Ｐａｉｄｙ合同会社
            (以下「乙」といいます。) の決済サービス（以下「本サービス」といいます。)
            を利用するにあたり、本規約の各条項を承認のうえ、乙に加盟店の申込みをするものとします。乙が甲に対して本申込みを承諾したときに、以下の条項を内容とする加盟店契約（以下「本契約」といいます。）が成立するものとします。なお、乙所定の手続きの結果、本契約が不成立となっても甲は異議を述べないものとします。
          </p>
          <h4>第１条（総則）</h4>
          <p>
            甲は本サービスの趣旨をよく理解し、特定商取引に関する法律、割賦販売法、消費者契約法、個人情報保護法、不当景品類及び不当表示防止法、犯罪による収益の移転防止に関する法律、資金決済に関する法律、その他関係法令を遵守し、本サービスの円滑なる運営推進を図るため乙と緊密な連携を保ち、相互に協力するものとします。
          </p>
          <h4>第２条（加盟店）</h4>
          <p className="item">
            １．甲は、本契約の締結をもって乙の加盟店（以下「加盟店」といいます。）の地位を得るものとします。
          </p>
          <p className="item">
            ２．甲は、加盟店として、本契約に定める信用販売（次条に定義します。）を行う店舗・施設（通信販売を行うウェブサイト等を含み、以下「取扱店舗」といいます。）を指定し、乙に通知するものとします。
          </p>
          <h4>第３条（定義）</h4>
          <p>
            本規約において、以下に掲げる用語の意義は、当該各号に定めるところによるものとします。
          </p>
          <p className="sub-item">
            ①信用販売
            <br />
            顧客と加盟店との間における、甲所定の方法により本サービスを対価の支払手段とする商品及び権利の販売並びにサービスの提供等の取引をいいます。
          </p>
          <p className="sub-item">
            ②商品等
            <br />
            甲と顧客間の売買又は役務提供等において対象となる物品、権利、及びサービス（附帯関連する役務を含みます。）等をいいます。
          </p>
          <p className="sub-item">
            ③顧客
            <br />
            乙が提供する本サービスによる信用販売を利用しようとする者をいいます。
          </p>
          <p className="sub-item">
            ④売上債権
            <br />
            信用販売により加盟店が顧客に対し取得する金銭債権をいいます。
          </p>
          <p className="sub-item">
            ⑤電子通信
            <br />
            インターネット、電話、ファックス等の電子通信機器を介して行う通信手段をいいます。
          </p>
          <p className="sub-item">
            ⑥営業秘密等
            <br />
            甲又は乙が本契約の履行上知り得た相手方の技術上又は営業上その他の秘密をいいます。
          </p>
          <p className="sub-item">
            ⑦第三者
            <br />
            甲、乙以外の全ての者をいいます。
          </p>
          <p className="sub-item">
            ⑧個人情報
            <br />
            顧客の個人情報（個人に関する情報で氏名・住所・生年月日その他の記述等により特定の個人を識別することができる情報をいい、氏名・住所・生年月日・電話番号・契約番号・預貯金口座・請求額をいいますが、これらに限りません。）をいいます。
          </p>
          <h4>第４条（業務委託の禁止）</h4>
          <p>
            甲は、乙に対して事前に書面等により通知する場合を除き、本契約に基づいて行う業務（個人情報に関する業務を含みます。）を第三者に委託できないものとします。
          </p>
          <h4>第５条（広告の作成）</h4>
          <p className="item">
            １．甲は、本サービスの利用に関し、本サービスに関する広告を作成する場合は、その内容について事前に乙に届け出るものとし、その実施は甲の責任と負担において行うものとします。
          </p>
          <p className="item">２．甲は、前項の広告の作成にあたり次の事項を遵守するものとします。</p>
          <p className="sub-item">
            ①特定商取引に関する法律、割賦販売法、不当景品類及び不当表示防止法、著作権法、商標法及びその他関連法令の定めに違反しないこと
          </p>
          <p className="sub-item">②顧客の判断に錯誤を与える虞のある表示をしないこと</p>
          <p className="item">３．甲は、通信販売を行う際は次の事項について表示するものとします。</p>
          <p className="sub-item">①加盟店の屋号・商号、所在地、代表者又は運営責任者の氏名</p>
          <p className="sub-item">
            ②加盟店の電話番号、電子メールアドレス等の照会窓口の連絡先、受付時間
          </p>
          <p className="sub-item">③商品の販売価格、送料、その他必要な料金</p>
          <p className="sub-item">
            ④商品の引渡時期及び方法（商品発送先に制限がある場合はその詳細）
          </p>
          <p className="sub-item">⑤代金の支払時期及び方法</p>
          <p className="sub-item">⑥商品の返品、申込みの取消に関する事項</p>
          <p className="sub-item">
            ⑦ソフトウェア等、デジタルコンテンツに関する取引の場合は、その動作環境
          </p>
          <p className="sub-item">
            ⑧分割払いの取引を行う場合は割賦販売法に定められている取引条件等に関する事項
          </p>
          <p className="sub-item">⑨その他乙が必要と認める事項</p>
          <h4>第６条（取扱商品）</h4>
          <p className="item">
            １．甲が、本サービスを利用して取扱う商品等（以下「取扱商品」といいます。）については、以下の何れかに該当するか又は該当する虞がある取扱商品を取り扱ってはならないものとします。なお、第１号および第５号については、乙はその裁量により、本契約の有効期間中、任意の時点において各号該当性の判断を行うことができるものとします。
          </p>
          <p className="sub-item">①乙が公序良俗に反すると判断するもの</p>
          <p className="sub-item">
            ②銃砲刀剣類所持等取締法、麻薬及び向精神薬取締法、絶滅のおそれのある野生動植物の種の国際取引に関する条約（ワシントン条約）、その他関連法令の定めに違反するもの
          </p>
          <p className="sub-item">
            ③第三者の特許権、商標権、実用新案権、意匠権、著作権その他知的財産権、及び肖像権その他の権利を侵害するもの
          </p>
          <p className="sub-item">
            ④乙の事前の承諾を得ない現金（記念硬貨等を含みます。）、商品券、印紙・切手、回数券・プリペイドカード、電子マネーその他の前払式支払手段等の換金性の高いもの（有価証券を含みます。）
          </p>
          <p className="sub-item">
            ⑤その他顧客との紛議若しくは不正利用の実態等に鑑み又は乙のブランドイメージ保持の観点から、乙が不適当と判断したもの
          </p>
          <p className="sub-item">⑥乙が別途指定したもの</p>
          <p className="item">
            ２．甲の取扱商品が、前項各号の何れかに該当すること若しくはその虞があることが判明した場合、又は、法令の変更等により、前項各号の何れかに該当すること（その虞がある場合を含みます。）となった場合、乙は、甲に対する何らの責任を負うことなく、当該取扱商品を本サービスの利用対象外商品とすることができるものとします。
          </p>
          <p className="item">
            ３．甲は、第１項の規定にかかわらず、商品等の販売又は提供を行うために行政機関からの許認可、行政機関への登録又は届出等（以下「許認可等」という）が必要な商品等について信用販売を行おうとする場合には、許認可等を得た後に当該信用販売を行うものとし、甲が当該許認可等を取り消され、又は停止されるなどした場合には当該商品等の販売等を行ってはならないものとします。なお、乙が要請した場合は甲は許認可等を証明する関連書類を乙に提出するものとします。
          </p>
          <h4>第７条（改善措置）</h4>
          <p className="item">
            １．乙は、甲が行っている信用販売が規定どおりに実施されているかどうか、及び、第５条の広告表現の適否を適宜調査することができるものとし、甲は乙の調査に協力するものとします。
          </p>
          <p className="item">
            ２．乙が甲に対して前条の取扱商品について報告を求めた場合には、甲は、速やかに報告を行うものとします。
          </p>
          <p className="item">
            ３．乙は、広告表現及び取扱商品の内容等が信用販売に相応しくないと判断し、改善措置等が必要又は適当と認めた場合には、甲に対して変更・改善若しくは販売中止を求めることができるものとし、甲はその要求に従い速やかに適切な措置を取るものとします。
          </p>
          <h4>第８条（本サービスによる信用販売）</h4>
          <p className="item">
            １．甲は、顧客が、本サービスを利用して、物品の販売、サービスの提供、その他甲の営業に属する取引を求めた場合には、本契約に従い、現金並びにその他の決済手段で取引を行う利用者と同様に、信用販売を行うものとします。この場合、甲は、本サービス利用に関し、顧客に対して、決済手数料を請求してはならないものとします。
          </p>
          <p className="item">
            ２．本規約の対象とする信用販売は、店頭販売等の対面取引及び通信販売等による非対面取引とします。
          </p>
          <p className="item">
            ３．甲は、本契約に従い信用販売を行うとともに、第１条に定める法令、乙が定める規程、ルール及び指示等（以下改定された場合は改定後のものを含み、「本契約等」といいます。）を遵守するものとします。
          </p>
          <h4>第９条（本サービスによる信用販売の種類）</h4>
          <p>
            本サービスによる信用販売は次のとおりとします。なお、乙は甲に対して、乙による加盟店審査完了後に甲が取扱可能な本サービスによる信用販売の種類を通知するものとします。
          </p>
          <p className="sub-item">
            ①一括払い（債権譲渡方式）
            <br />
            顧客が甲に対して支払うべき商品等の代金、送料及び甲が任意に定める手数料を加算した金額（以下「商品代金等」といいます。）の代金債権（以下「売上債権」といいます。）を乙が有償で買い受ける（以下その債権譲渡代金を「譲渡代金」といいます。）とともに、乙から顧客に対して請求書を送付し、顧客が乙指定の期日（利用日が属する月の翌月の指定日）までに一括して乙に支払うサービス
          </p>
          <p className="sub-item">
            ②一括払い（立替払い方式）
            <br />
            顧客が甲に対して支払うべき商品代金等を、乙が顧客の委託に基づいて顧客に代わって立替払い（以下当該代金を「立替代金」といいます。）するとともに、乙から顧客に対して請求書を送付し、顧客が乙指定の期日（利用日が属する月の翌月の指定日）までに一括して乙に支払うサービス
          </p>
          <p className="sub-item">
            ③分割払い（立替払い方式）
            <br />
            顧客からの委託に基づき商品代金等を乙から甲へ交付し、更に乙が顧客より分割して立替代金の返済を受けるものをいい、顧客は申込の都度、支払回数（乙が定めた任意の回数）を指定して、乙指定の支払方法によって分割払いを行うサービス
          </p>
          <h4>第１０条（本サービスによる信用販売の方法）</h4>
          <p className="item">
            １．甲は、顧客より本サービスの信用販売の申込みを受けたときは、次条に定める申込データを乙に送信し、遅滞なく全件について、乙の定める方法により、信用販売の承認を得るものとし、乙の承認が得られなかった場合は本サービスによる信用販売を行わないものとします。
          </p>
          <p className="item">
            ２．前条第①号（一括払い（債権譲渡方式））の信用販売の申込みを受け付けた際の手続は次の方法とします。
          </p>
          <p className="sub-item">
            ①甲は、当該申込みの事実及び申込データを、乙の指定する方法により乙に通知し承認を依頼するものとします。
          </p>
          <p className="sub-item">
            ②乙は前号により承認の依頼を受けたときは、顧客の信用調査を行い、承認の可否を電子的方法により甲に通知するものとします。
          </p>
          <p>③未成年者の申込みの場合は、親権者の同意を必要とするものとします。</p>
          <p className="item">
            ３．前条第①号（一括払い（債権譲渡方式））以外の信用販売の申込みを受け付けた際の手続は次の方法とします。
          </p>
          <p className="sub-item">
            ①甲は、乙所定の方法により受け付けを行い、当該申込みの事実及び申込データを、乙の指定する方法により乙に通知し承認を依頼するものとします。
          </p>
          <p className="sub-item">
            ②乙は、顧客に乙所定の入力画面を提供し、乙が指定する項目を入力させ、与信審査を行うものとします。
          </p>
          <p className="sub-item">
            ③甲は、乙より「可」又は「不可」の通知を受けたときは、その旨を顧客に通知するものとします。但し、一括払い（債権譲渡方式）の申込み後、分割払いへの変更を希望した顧客が甲を介することなく自ら乙が提供する画面において分割払いの申込みを行った場合は、甲は乙に対し、割賦販売法３５条の３の２に基づく取引条件の表示業務及び同法３５条の３の８に基づく書面交付業務、および割賦販売法第３０条の２の３第４項に基づく情報提供義務及び同条第５項に基づく書面交付義務を委託するものとし、乙は、顧客に対して与信審査の結果を直接通知するとともに、甲の委託に基づいて、当該取引条件、当該情報提供及び書面交付を電磁的方法により顧客に行うものとします。
          </p>
          <p>④未成年者の申込みの場合は、別途乙が定める方法によるものとします。</p>
          <p className="item">
            ４．乙は、乙の信用調査の方法及び結果の理由を甲に開示する義務を負わないものとします。
          </p>
          <p className="item">
            ５．本サービスの申込みの単位は、１注文毎とし、複数の取扱商品があった場合でも、乙は１件の申込みとして処理するものとします。
          </p>
          <h4>第１１条（申込みデータの取扱い）</h4>
          <p className="item">
            １．第１０条第１項に基づき甲が乙に送信する申込データ（以下「申込データ」といいます。）は以下の情報とします。
          </p>
          <p className="sub-item">
            ①顧客の住所、氏名(漢字、カナ)、生年月日、携帯電話番号、Ｅメールアドレス
          </p>
          <p className="sub-item">
            ②取引対象商品等の特定（商品名・サービスの内容・商品番号・数量等）
          </p>
          <p className="sub-item">
            ③甲が顧客に対しその取引によって取得する売上債権の金額（送料・甲が予め顧客と同意した費用・消費税額を含みます。）
          </p>
          <p className="sub-item">④商品の配送が必要な場合、商品の配送先住所</p>
          <p className="sub-item">⑤その他甲と乙が合意した事項</p>
          <p>
            なお、前１号ないし４号の申込データについて提供できない場合は甲・乙協議のうえ、申込みデータの内容を調整するものとします。
          </p>
          <p className="item">
            ２．甲は、申込データの電子通信に用いるデータの構造、書式、顧客の端末に表示されるデータ記入用画面等（なお、これらに係る著作権その他一切の権利は乙が有するものとします。）を乙の指定する仕様書に基づいて予め導入し、乙の許諾を得てこれを使用するものとします。
          </p>
          <p className="item">
            ３．甲・乙間で行うデータの授受に関しては、暗号化（ＳＳＬ及びそれと同等な技術を含みます。）して行うものとします。
          </p>
          <p className="item">
            ４．甲は、電子通信の手段によって取引行為を行うことができる旨を顧客に告知し、かつ、データ記入用画面を表示するときは、当該データを暗号化しても完全に秘密性が保持できないこと、及びデータの秘密性が保持できなかった場合でも乙には一切の責任がないことについて同意を得るものとします。
          </p>
          <p className="item">
            ５．甲は、申込データを記録したファイル及び次のデータ等を保管するものとします。なお、下記データ等の保管ができない場合は甲・乙協議の上、調整するものとします。
          </p>
          <p className="sub-item">①申込データ</p>
          <p className="sub-item">②商品等が発送済み又は提供（完了）済みである旨の記録</p>
          <p className="sub-item">
            ③商品等を発送した際の運送機関の荷受伝票、その他運送の受託を証する書面又は電磁的記録
          </p>
          <p className="sub-item">
            ④本サービスを利用して販売された商品等については、顧客が受領したことを証する書面又は電磁的記録
          </p>
          <p className="sub-item">
            ⑤本サービスを利用して提供された役務・サービスについては、その提供を行った日時、場所、サービス内容、及び提供者等が記載された書面又は電磁的記録
          </p>
          <p className="sub-item">
            ⑥本サービスを利用して提供されたデジタルコンテンツについては、データをダウンロードした日時、媒体等が記載された書面又は電磁的記録
          </p>
          <p className="sub-item">⑦その他甲と乙が合意したファイル及びデータ等</p>
          <h4>第１２条（商品の発送・提供等）</h4>
          <p className="item">
            １．甲は、顧客から信用販売の申込みを受け付け、乙から第１０条に定める信用販売の承認の通知を受け取った場合、速やかに申込データ等に記載されている、時期、場所、方法等により、顧客に対する商品等の引渡し又はサービスの提供（デジタルコンテンツ等のダウンロード、ストリーミング、その他電子媒体による商品提供を含みます。）を行うものとします。
          </p>
          <p className="item">
            ２．商品等の送付先ないし提供先は、乙が承認した顧客の住所地又は甲の店舗等とします。
          </p>
          <p className="item">
            ３．商品等の引渡し等が遅延、品切れ、又は提供するサービスが未提供等、申込時の約定と異なる場合が生じた場合は、甲は遅滞なく当該顧客及び乙に対し連絡を行い、書面等で引渡時期等を通知するものとします。
          </p>
          <h4>第１３条（請求金額の通知（一括払い（債権譲渡方式））</h4>
          <p className="item">
            １．甲は、一括払い（債権譲渡方式）の場合には、甲が次項に従い提出した、本サービスを利用した信用販売にかかる売上のデータ（以下「売上データ」といいます。）が乙のシステムによって事故なく読み込まれた時点をもって、顧客に対する売上債権を乙に対して譲渡するものとし、乙はこれを譲渡代金をもって譲り受けるものとします。
          </p>
          <p className="item">
            ２．甲は、乙に対し、顧客との間で取扱商品等に関する売買契約又は役務提供契約（以下総称して「売買契約等」といいます。）を締結した後、速やかに売上データを乙所定の方法により提出することにより、譲渡代金の請求を行うものとします。また、甲は、乙から第１０条第１項の販売承認を得た後、乙所定の期間を経過しても当該販売に係る売上債権の売上データを乙宛てに提出しなかった場合は、当該売上債権に係る債権譲渡を行うことができず、乙に対し譲渡代金の請求を行うこともできないものとします。
          </p>
          <p className="item">
            ３．甲は、売上債権を第三者に譲渡し、若しくは立替えて支払わせることはできないものとします。
          </p>
          <p className="item">
            ４．甲は、第１項の債権譲渡に関し、顧客より異議なき承諾を得るものとします。
          </p>
          <h4>第１４条（立替払契約の成立（一括払い（立替払い方式）・分割払い）</h4>
          <p className="item">
            １．乙と顧客間の立替払契約は、乙が甲に顧客の立替払いを承諾した時点で成立するものとします。
          </p>
          <p className="item">
            ２．甲は、乙に対し、顧客との間で売買契約等を締結した後、速やかに売上データを提出することにより、乙が甲に対して支払うべき立替代金の支払請求を行うものとします。
          </p>
          <p className="item">
            ３．甲が乙所定の期間内に売上データを提出しなかったときは、乙は、第１５条に定める立替代金を支払う義務を負わないものとします。この場合、乙は、顧客との間の立替払契約を解約の上、顧客に対して、その旨の通知を行うことができるものとします。
          </p>
          <h4>第１５条（譲渡代金・立替代金の支払方法）</h4>
          <p className="item">
            １．乙が譲渡を受けた売上債権の譲渡代金又は立替代金の締切日、及び甲への支払方法は、乙が別途発行する通知書に記載のとおりとします。
          </p>
          <p className="item">
            ２．前項の支払いは、支払日における合計額から第２０条に定める手数料を控除した代金を甲が指定した金融機関へ乙が振込む方法により行うものとします。
          </p>
          <p className="item">
            ３．第１項の規定にかかわらず、甲が提出した売上データ又は売上データに係る信用販売が以下の各号に該当する場合は、乙による当該信用販売に係る承認の有無にかかわらず、乙は、乙が甲に負担する譲渡代金又は立替代金の支払義務を負わないものとします。また、当該譲渡代金又は立替代金が既に支払済みの場合には、甲は、乙の請求があり次第直ちに当該金銭を返還するものとします。
          </p>
          <p className="sub-item">
            ①顧客から、自己の利用によるものではない旨の申し出が甲又は乙に対してあった場合
          </p>
          <p className="sub-item">
            ②顧客から、商品等の受領ができない旨の申し出があり、かつ、甲からも顧客による商品等の受領の記録が提出されない場合
          </p>
          <p className="sub-item">
            ③売上データが正当なものでない場合、又は売上データの内容に不実・不備がある場合
          </p>
          <p className="sub-item">
            ④甲が提出した売上データ又は売上データに係る信用販売が法令又は本契約に違反する場合
          </p>
          <p className="sub-item">
            ⑤甲が提出した売上データに係る信用販売の対象となる取扱商品が存在しない場合又は犯罪による収益である疑いがある場合
          </p>
          <p className="sub-item">⑥次項の調査に対して乙が合理的と認める協力を、甲がしない場合</p>
          <p className="sub-item">⑦第１６条の返品等がなされた場合</p>
          <p className="sub-item">⑧第１７条第１項の顧客との紛議が解決されない場合</p>
          <p className="item">
            ４．乙は、甲から提出された売上データについて、前項各号に該当する疑義があると乙が認めた場合、その疑義が解消されるまで当該売上データにかかる売上債権の譲渡代金又は立替代金の支払いを留保することができるものとします。この場合、留保した支払代金について法定利息その他遅延損害金は発生しないものとします。また、甲は、当該売上データにかかる資料の提示・提出等について、乙の調査に協力するものとします。
          </p>
          <p className="item">
            ５．甲は、乙が本条第１項に基づき立替代金の支払いを行ったときは、甲が顧客に対して有する商品代金等に関する債権に代位することを予め承諾するものとします。
          </p>
          <h4>第１６条（返品等）</h4>
          <p className="item">
            １．甲は、顧客から商品等の返品ないしキャンセル（以下「返品等」といいます。）の申出を受け、これを受領した場合、次のとおり取り扱うものとします。
          </p>
          <p className="sub-item">
            ①甲は、返品等を受けた日を返品日とし、直ちに乙所定の売上データの顧客氏名、金額、返品日、返品の表示、その他必要事項を乙所定の方法により乙へ通知するものとします。
          </p>
          <p className="sub-item">
            ②甲は、前号にかかわらず、乙から別途の指示があった場合は、それに従うものとします。
          </p>
          <p className="item">
            ２．乙が前項第１号により返品等の通知を受けた際は、当該返品等に係る売上債権につき既に顧客から乙に支払がなされている場合は、その精算は顧客と乙において処理されるものとします。
          </p>
          <p className="item">
            ３．第１項に基づく返品等があった場合、乙は、乙の甲に対する譲渡代金返還請求権又は立替代金返還請求権及び第１５条３項に基づく乙の甲に対する譲渡代金返還請求権又は立替代金返還請求権に関しては、乙は、甲に対する本契約に基づく支払債務と対当額の範囲で相殺することができるものとします。
          </p>
          <p className="item">
            ４．前項に基づく相殺を行ったにもかかわらず、乙が譲渡代金又は立替代金の返還請求をした日（乙が口頭又は文書により甲に通知した日とします。）から２か月以上を経過した未払いの精算金（第１項又は第１５条３項に基づき甲が乙に対して返還を要する譲渡代金又は立替代金）がある場合は、甲は乙の請求により遅滞なくその残額を一括にて支払うものとします。
          </p>
          <h4>第１７条（顧客との紛議と信用販売利用代金等）</h4>
          <p className="item">
            １．甲は、顧客に対して販売した商品等の品質不良、瑕疵、運送中の破損、数量不足、品違いその他、販売した商品等に関する顧客との紛議については、遅滞なくこれを自らの責任と費用負担において、解決するものとします。
          </p>
          <p className="item">
            ２．甲は、前項の紛議に際して顧客から返品等の申出があった場合には、速やかにこれに応じて前条の処置を取るものとします。
          </p>
          <p className="item">
            ３．第１項の紛議を理由に顧客が当該商品代金等の支払いを拒否した場合、又は、顧客紛議が発生する可能性があると乙が認めた場合、乙は紛議が解決するまで甲に対する譲渡代金ないし立替代金の全部又は一部の支払いを留保できるものとします。この場合、留保した譲渡代金ないし立替代金について法定利息その他遅延損害金は発生しないものとします。
          </p>
          <h4>第１８条（顧客との紛議に関する措置等）</h4>
          <p className="item">
            １．顧客と乙との間に紛議が生じた場合、甲は、乙の求めに応じて、顧客との取引の態様（当該販売の内容、勧誘行為がある場合にはその内容）、紛議の発生要因等について乙に報告するものとします。
          </p>
          <p className="item">
            ２．甲は、前項の報告その他乙の調査の結果、乙が顧客の紛議が甲の割賦販売法３５条の３の７に規定される行為その他法令で禁止されている行為に起因するものと認めた場合には、当該行為の防止体制、苦情処理体制に関する事項、その他当該行為の防止のために乙が必要と認める事項を、乙の求めに応じて報告しなければならないものとします。
          </p>
          <p className="item">
            ３．甲は、第１項の報告、乙が加盟する認定割賦販売協会の保有する情報その他の方法による乙の調査の結果、乙が顧客の紛議の発生状況が、他の加盟店と比較して顧客の利益の保護に欠けると認める場合には、当該行為の詳細事項、当該行為の防止体制、苦情処理体制に関する事項その他の当該行為の防止のために乙が必要と認める事項を、乙の求めに応じて報告しなければならないものとします。
          </p>
          <p className="item">
            ４．乙は、前３項の報告その他乙の調査の結果、必要があると認める場合には、甲に対し、下記の措置及び指導を行うことができ、甲はこれに従うものとします。但し、乙による措置及び指導は、甲を免責するものではないものとします。
          </p>
          <p className="sub-item">①書面若しくは口頭による改善要請</p>
          <p className="sub-item">②信用販売の停止</p>
          <p className="sub-item">③本契約の解除</p>
          <h4>第１９条（一括払いにおける買戻しの特約）</h4>
          <p className="item">
            １．第１０条３項３号但書に定める、一括払い（債権譲渡方式）から分割払いへの変更が行われた場合であって、既に甲が乙に対し売上債権を譲渡している場合、甲は乙の請求により遅滞なく売上債権を買い戻すものとします。
          </p>
          <p className="item">
            ２．甲は、一括払い（債権譲渡方式）の場合において、第１５条３項各号のいずれかに該当した場合、乙の請求により遅滞なく当該売上債権を買戻すものとします。また、乙は、第１５条３項各号のいずれかの事由が存在すると合理的に判断する場合には、甲に対し、当該事由の存否を照会することができ、甲は速やかに、当該事由の不存在を証明しなければならないものとします。甲がこの証明を行わない場合には、甲は、乙の請求により遅滞なく当該売上債権を買戻すものとします。
          </p>
          <p className="item">
            ３．乙の通知、意思表示を受領すべき甲の連絡先が不明となったときは、乙は本条第２項の請求に係る通知を省略して本条の手続を取ることができるものとします。
          </p>
          <h4>第２０条（手数料の支払い）</h4>
          <p className="item">
            １．甲は、本サービスによる信用販売額に対して乙所定の料率を乗じて計算した手数料（乙が別途発行する通知書に記載）を乙に支払うものとします。１円未満の端数が生じた場合は切り捨てとします。
          </p>
          <p className="item">
            ２．第１６条及び第１９条により甲から乙に返品若しくは買戻しの精算が行われる場合においても、本条に規定する手数料は返還されないものとします。
          </p>
          <h4>第２１条（サービスの中断・免責事項）</h4>
          <p className="item">
            １．乙は、コンピュータシステムの不備、天災、事変、騒乱、暴動その他乙の責めに帰すことのない事由により本サービスを提供ができなくなったときは、甲に通知することなく本サービスの提供を中断することができるものとします。
          </p>
          <p className="item">
            ２．乙は、以下の各号に定める事由に該当する場合、又は本サービスの提供に必要な設備の保守点検等の事由により本サービスの提供を中断すべきであると判断したときは、甲に事前に通知して本サービスの提供を中断することができるものとします。
            <br />
            この場合、乙は甲及び顧客に対し、債務不履行責任、不法行為責任、その他の法律上の原因の如何を問わず賠償の責任を負わないものとします。
          </p>
          <p className="sub-item">①天災、事変、騒乱、暴動その他の不可抗力な非常事態</p>
          <p className="sub-item">
            ②本サービスを提供しているコンピュータシステム並びに甲及び顧客のコンピュータ、電気通信設備の障害、インターネット接続サービスの不具合等、甲及び顧客の設備、接続環境の障害及び郵便の誤謬、遅延
          </p>
          <p className="sub-item">
            ③乙が第三者から導入しているコンピュータウイルス対策ソフトについて当該第三者からウイルスパターン、ウイルス定義ファイル等を提供されていない種類のコンピュータウイルスの侵入
          </p>
          <p className="sub-item">
            ④乙が善良なる管理者の注意をもってしても防御し得ない第三者による不正アクセス又はアタック、通信経路上での傍受
          </p>
          <p className="sub-item">
            ⑤電気通信事業者の提供する電気通信役務の不具合、その他、電気通信事業者の責に帰すべき事由
          </p>
          <p className="item">
            ３．乙は、以下の各号に定める損害、又は乙の責めに帰さない事由により甲若しくは顧客に生じた損害に関し、甲及び顧客に対し、不法行為責任、その他の法律上の原因の如何を問わず賠償の責任を負わないものとします。
          </p>
          <p className="sub-item">
            ①ＩＤ、パスワード等を甲又は顧客自身が入力したか否かにかかわらず、予め乙に登録されている情報との一致を乙が確認して行った取引により生じた損害
          </p>
          <p className="sub-item">
            ②甲が乙所定のセキュリティ要件を充足せずに行った取引により生じた損害
          </p>
          <p className="sub-item">
            ③乙の営業時間外（取引時間内のシステムメンテナンスにより取引が行われない時間を含みます。）のために、甲の依頼に応じ得ないことにより生じた損害　　
          </p>
          <p className="sub-item">
            ④甲により作成された決済データに誤謬、欠陥が存在したことによる損害又は本サービスに関連して乙が提供した情報に誤謬、欠陥が存在したことにより生じた損害（乙に故意又は重大な過失がある場合を除きます。）
          </p>
          <p className="sub-item">
            ⑤乙が甲の指定する金融機関の口座に送金を行ったにも拘らず、当該取引の送金が乙の責めに帰すべき事由によらず生じた損害
          </p>
          <p className="item">
            ４．乙は、甲及び顧客が本サービスを利用することにより、第三者との間で生じた紛争について一切の責任を負わないものとし、甲は当該紛争を自らの費用と責任で解決するものとします。
          </p>
          <h4>第２２条（営業秘密等の守秘義務等）</h4>
          <p className="item">
            １．甲は、本契約に関して開示された乙の営業秘密等を、乙の書面による事前の同意を得ることなく、第三者に提供・開示・漏洩せず、本契約に定める業務目的以外の目的に利用しないものとします。但し、以下の何れかに該当することが証明された情報は営業秘密等に含まれないものとします。
          </p>
          <p className="sub-item">①当該情報を受領した時点で、既に公知であった情報</p>
          <p className="sub-item">
            ②当該情報を受領した後に、当該情報を受領した当事者の責めに帰すべき事由によらず公知となった情報
          </p>
          <p className="sub-item">
            ③当該情報を受領した時点で、当該情報を受領した者が既に保有していた情報（守秘義務の制約の下で相手方から開示された情報を除きます。）
          </p>
          <p className="sub-item">
            ④当該情報を受領した後に、守秘義務に服さない第三者から守秘義務を負うことなく適法かつ正当に開示を受けた情報
          </p>
          <p className="item">
            ２．前項の営業秘密等には、乙が甲に提供する事務連絡の情報等が含まれるものとします。
          </p>
          <p className="item">
            ３．甲は、営業秘密等を滅失・毀損・漏洩等することがないよう必要な措置を講ずるものとし、第１項に従い、営業秘密等の開示ができる場合であっても、当該情報の滅失・毀損・漏洩等に関し責任を負うものとします。
          </p>
          <p className="item">
            ４．甲は、営業秘密等をその責任において万全に保管するものとし、本契約が終了した場合に乙の指示があるときは、その指示内容に従い返却又は廃棄するものとします。
          </p>
          <p className="item">５．本条の定めは本契約終了後も有効とします。</p>
          <h4>第２３条（個人情報の守秘義務等）</h4>
          <p className="item">
            １．甲及び乙は、相手方から提供された個人情報がある場合は、これを秘密として保持し、相手方の書面による事前の同意を得ることなく、第三者に提供・開示・漏洩せず、本規約に定める業務目的以外の目的に利用しないものとします。ただし、乙が顧客の同意を得て第三者に提供する場合を除きます。
          </p>
          <p className="item">
            ２．甲及び乙は、個人情報を滅失・毀損・漏洩等することがないよう必要な措置を講ずるものとし、個人情報の滅失・毀損・漏洩等に関し責任を負うものとします。
          </p>
          <p className="item">３．本条の定めは本契約終了後も有効とします。</p>
          <h4>第２４条（委託の場合の個人情報等の取扱い）</h4>
          <p className="item">
            １．甲は、本契約に関わる業務処理を第４条に従い第三者に委託する場合（数次委託を含むものとし、以下同じ。以下、この委託を受けた第三者を「委託先」といいます。）には、乙の事前の承認を得た上で、十分な個人情報の保護水準を満たしている委託先を選定し委託先に本契約における甲と同様の機密保持義務及び個人情報管理措置義務等を課す内容を含む契約を委託先と締結するものとします。但し、甲が乙の同意を得て委託を行う場合であっても、本契約上の甲の義務及び責任は一切免除又は軽減されないものとします。委託先は甲の履行補助者であり、委託先の行為及び故意・過失は、甲の行為及び故意・過失と見做すものとします。
          </p>
          <p className="item">２．本条の定めは本契約終了後も有効とします。</p>
          <h4>第２５条（届出事項の変更等）</h4>
          <p className="item">
            １．甲は、乙に対して届け出ている商号、代表者、所在地、取扱店舗、連絡先、指定金融機関口座等、加盟店申込書記載事項に変更が生じた場合、乙所定の方法により遅滞なく乙に届け出るものとします。
          </p>
          <p className="item">
            ２．甲は、前項の届出がないために乙からの通知（通知の種類、内容は限定されないものとします。）、又はその他送付書類、第１５条に規定する振込金が延着し、又は到着しなかった場合には、通常到着すべき時点に甲に到着したものと見做すことに異議を述べないものとします。
          </p>
          <h4>第２６条（反社会勢力の排除）</h4>
          <p className="item">
            １．甲は、自ら及び親会社・子会社等の関係会社、並びにそれらの役員、従業員等（以下「関連会社等」という。）
            が現在、次のいずれにも該当しないこと、かつ将来にわたっても該当しないことを確約します。
          </p>
          <p className="sub-item">
            ①暴力団（その団体の構成員（その団体の構成団体の構成員を含む）が集団的にまたは常習的に暴力的不法行為等を行うことを助長する虞がある団体）
          </p>
          <p className="sub-item">
            ②暴力団員（暴力団の構成員）及び暴力団員でなくなった時から５年を経過しない者
          </p>
          <p className="sub-item">
            ③暴力団準構成員（暴力団員以外の暴力団と関係を有する者であって、暴力団の威力を背景に暴力的不法行為等を行う虞があるもの、または暴力団若しくは暴力団員に対し資金、武器等の供給を行うなど暴力団の維持若しくは運営に協力し、若しくは関与するもの）
          </p>
          <p className="sub-item">
            ④暴力団関係企業（暴力団員が実質的にその経営に関与している企業、準構成員若しくは元暴力団員が経営する企業で暴力団に資金提供を行うなど暴力団の維持若しくは運営に積極的に協力し若しくは関与する企業または業務の遂行等において積極的に暴力団を利用し暴力団の維持若しくは運営に協力している企業）
          </p>
          <p className="sub-item">
            ⑤総会屋等（総会屋、会社ゴロ等企業等を対象に不正な利益を求めて暴力的不法行為等を行う虞があり、市民生活の安全に脅威を与える者）　　
          </p>
          <p className="sub-item">
            ⑥社会運動等標ぼうゴロ（社会運動若しくは政治活動を仮装し、または標ぼうして、不正な利益を求めて暴力的不法行為等を行う虞があり、市民社会の安全に脅威を与える者）
          </p>
          <p className="sub-item">
            ⑦特殊知能暴力集団等（前各号に掲げる者以外の、暴力団との関係を背景に、その威力を用い、または暴力団との資金的なつながりを有し、構造的な不正の中核となっている集団または個人）
          </p>
          <p className="sub-item">⑧その他上記①～⑦に準ずるもの、及び①～⑦の共生者。</p>
          <p className="item">
            ２．甲は、自ら及び関連会社等が自ら又は第三者を利用して次の各号の一にでも該当する行為を行わないことを確約します。
          </p>
          <p className="sub-item">①暴力的な要求行為</p>
          <p className="sub-item">②法的な責任を超えた不当な要求行為</p>
          <p className="sub-item">
            ③取引（利用、代金支払、付帯サービス等含む）に関して、脅迫的な言動をし、または暴力を用いる行為
          </p>
          <p className="sub-item">
            ④風説を流布し、偽計を用いまたは威力を用いて乙の信用を毀損し、または乙の業務を妨害する行為
          </p>
          <p className="sub-item">⑤その他前各号に準ずる行為</p>
          <p className="item">
            ３．乙は甲に対して、甲の関連会社等が前項に定める事項に反すると具体的に疑われる場合には、当該事項に関する報告を求めることができ、乙がその報告を求めた場合、甲は乙に対して合理的な期間内に報告書を提出しなければならないものとします。
          </p>
          <p className="item">
            ４．乙は、甲が第１項あるいは第２項の規定に違反している疑いがあると認めた場合には、本契約に基づく本サービスを一時的に停止することができ、この求めがあった場合、甲は、乙が取引再開を認めるまでの間、本サービスを利用できないものとします。
          </p>
          <p className="item">
            ５．甲が第１項あるいは第２項の規定に違反していることが判明した場合、または第１項あるいは第２項の規定に基づく確約に関して虚偽の申告をしたことが判明し、乙との本サービスの取引を継続することが不適切である場合には、乙は、直ちに本約を解除できるものとし、かつ、甲は乙に対する一切の未払債務を直ちに支払うものとし、その場合乙に生じた損害を甲が賠償するものとします。
          </p>
          <p className="item">
            ６．前項の規定により本契約を解除した場合でも、乙に対する未払債務があるときには、それが完済されるまでは本規約の各条項が適用されるものとします。
          </p>
          <h4>第２７条（契約解除等）</h4>
          <p className="item">
            １．第２９条の規定にかかわらず、以下各号の何れかの事態が発生した場合、又は乙が発生しているものと認めた場合、乙は、本契約を直ちに解除できるものとします。この場合、甲の乙に対する一切の未払債務は当然に期限の利益を失うものとし、乙は、解除の効力発生前に、何らの通知を要することなく、直ちに本規約による取引を停止させることができるものとします。
          </p>
          <p className="sub-item">
            ①甲が他の信用販売を取り扱う会社との取引にかかる場合も含めて信用販売制度を悪用していることが判明した場合
          </p>
          <p className="sub-item">②甲の営業又は業態が公序良俗に反すると乙が判断した場合</p>
          <p className="sub-item">③甲が監督官庁から営業の取消又は停止処分を受けた場合</p>
          <p className="sub-item">
            ④甲が自ら振出し若しくは引受けた手形又は小切手につき不渡処分を受ける等支払停止状態に至った場合
          </p>
          <p className="sub-item">
            ⑤甲が差押、仮差押、仮処分、租税滞納処分を受け、又は民事再生手続の開始、会社更生手続の開始、破産その他これに類似する倒産手続の開始、若しくは競売を申立てられ、又は自ら民事再生手続の開始、会社更生手続の開始若しくは破産その他これに類似する倒産手続の申立てを行った場合
          </p>
          <p className="sub-item">
            ⑥甲にその他経営状態が悪化し又はその虞があると認められる相当の事由がある場合
          </p>
          <p className="sub-item">⑦甲が届出た取扱店舗が実在しない場合</p>
          <p className="sub-item">
            ⑧甲が割賦販売法、特定商取引に関する法律、消費者契約法等の法令に違反していることが判明した場合
          </p>
          <p className="sub-item">
            ⑨甲が本規約に定める届出（変更の届出を含みます。）に記載事項を偽って記載したことが判明した場合
          </p>
          <p className="sub-item">
            ⑩本規約に伴う甲の地位又は債権を、乙の承諾なく第三者に譲渡する行為を行った場合
          </p>
          <p className="sub-item">
            ⑪第６条、第８条及び第１０条に定める手続によらずに信用販売を行った場合
          </p>
          <p className="sub-item">⑫第１５条第４項に定める乙の調査に対し協力を行わない場合</p>
          <p className="sub-item">⑬第７条の規定に違反して乙の改善措置の要求に従わない場合</p>
          <p className="sub-item">⑭第１９条の規定に違反して買戻しに応じない場合</p>
          <p className="sub-item">
            ⑮その他甲が、本規約に違反した場合若しくは乙が加盟店として不適当と認めた場合
          </p>
          <p className="item">
            ２．前項各号の何れかの事態が発生した場合、前項に基づき本契約を解除するか否かにかかわらず、乙は、何らの通知を要することなく、当該事態発生前に生じていたか又は当該事態発生後に生じたかにかかわらず、本規約に基づく債務の全部又は一部の支払を留保することができるものとします。この場合、乙は、当該事態の発生前に生じた遅延損害金を除き、法定利息その他遅延損害金の支払義務を負わないものとします。
          </p>
          <p className="item">
            ３．第１項第３号ないし第５号の何れかの事態が発生した場合、本規約に基づき乙が甲に対し負担する金銭債務その他の財務給付を行うべき債務と乙が甲に対して請求することのできる一切の金銭債権（本規約に基づくものであるか否かは問わないものとします。）とは、何らの意思表示を要せず、当然に対当額で相殺されるものとします。
          </p>
          <p className="item">
            ４．乙は、甲が本規約の規定に違反している疑いがあると認めた場合には、本規約に基づく信用販売を一時的に停止することができるものとします。信用販売を一時停止した場合には、甲は、乙が取引再開を認めるまでの間、信用販売を行うことができないものとします。これにより甲に損害が生じた場合でも乙に何らの請求は行わず、一切甲の責任とします。
          </p>
          <h4>第２８条（損害賠償）</h4>
          <p className="item">
            １．甲が本契約等に違反して信用販売を行った等、甲の責めに帰すべき事由により乙が損害を被った場合には、甲は乙に対し当該損害を賠償する責任を負うものとします。
          </p>
          <p className="item">
            ２．甲が本契約等に基づき支払いをなすべく日までに支払いを行わない場合、甲は支払日の翌日から年１４．６％の割合による遅延損害金を支払うものとします。
          </p>
          <h4>第２９条（有効期間・解約等）</h4>
          <p className="item">
            １．本規約の有効期間は本契約締結後１年間とします。但し、甲又は乙が、期間満了の１カ月前までに書面をもって本契約を更新しない旨の通知をしないときは更に１年間自動的に更新し、以後も同様とします。また本契約の有効期間中であっても、甲又は乙が、１カ月前までに書面による通知を行うことにより、本契約を解約できるものとします。
          </p>
          <p className="item">
            ２．理由の如何を問わず、本契約が終了したときは、甲は速やかに、本規約の存在を前提とした広告宣伝、取引申込みの誘引行為を中止し、本契約終了時点で乙に対する信用販売の承認請求を行っていないものについては、本サービスの対象外とし、甲は当該顧客に対して本規約に基づく本サービス取扱を中止した旨を告知するものとします。
          </p>
          <p className="item">
            ３．前項の場合、本契約終了時点で乙に対する信用販売の承認請求は行われているものの、未処理の案件については、本契約終了後も同処理が完了するまでの間、本規約はその効力を有するものとします。
          </p>
          <h4>第３０条（本規約の変更、承認）</h4>
          <p>
            乙は甲に対して、本規約を変更した場合に、当該変更内容および新規約を通知するものとします。甲がその通知を受けた後において顧客に対して信用販売を行った場合には、変更事項又は新規約を承認したものと見做します。
          </p>
          <h4>第３１条（協議事項）</h4>
          <p>本規約に定めのない事項については、甲・乙双方の協議により定めるものとします。</p>
          <h4>第３２条（準拠法）</h4>
          <p>本契約等に関する準拠法はすべて日本法とします。</p>
          <h4>第３３条（専属的合意管轄裁判所）</h4>
          <p>
            甲と乙との間で訴訟等の紛争が生じた場合は、乙の本店所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。
          </p>
          <p>改定：2025年11月28日</p>
        </>
      );

      break;
    }
    case 'merchant-info': {
      title = '加盟店情報の取扱いに関する同意条項';
      content = (
        <>
          <h4>第１条（加盟店取引に関する情報の取得・保有・利用の同意）</h4>
          <p className="item">
            １．加盟店及び代表者は、Ｐａｉｄｙ合同会社（以下、当社」という）が加盟申込時の審査、本契約締結後の加盟店調査、加盟店に対する措置及び取引継続にかかる審査、顧客に対する当社の債権の管理又は譲渡等の当社の業務、並びに当社の事業にかかる商品開発若しくは市場調査（これらの目的のために第三者に提供することを含みます）を目的として、加盟店にかかる次の各情報（以下、これらの情報を総称して「加盟店取引に関する情報」という）を当社が適当と認める保護措置を講じた上で当社が取得・保有・利用することに同意します。また、加盟店は、二重加盟や二重契約の防止等の理由から他の加盟店にかかる加盟店審査並びに加盟後の加盟店管理及び取引継続にかかる審査のために加盟店情報を利用することに同意します。
          </p>
          <p className="sub-item">
            ①加盟店の商号（名称）、所在地、郵便番号、電話（ＦＡＸ）番号、代表者の氏名、性別、住所、生年月日、自宅電話番号等、加盟店が加盟申込時及び変更届出時に届出た情報
          </p>
          <p className="sub-item">
            ②加盟申込日、加盟店契約日、加盟店契約終了日及び加盟店と当社との取引に関する情報
          </p>
          <p className="sub-item">③加盟店の営業許可証等の確認書類の記載事項に関する情報</p>
          <p className="sub-item">
            ④当社が加盟店又は公的機関から適法かつ適正な方法により取得した登記簿謄本、住民票、納税証明書等の記載事項に関する情報
          </p>
          <p className="sub-item">
            ⑤官報、電話帳、住宅地図等において公開されている加盟店に関する情報
          </p>
          <p className="sub-item">
            ⑥公的機関、消費者団体、報道機関等が公表した加盟店に関する情報及び当該内容について当社が調査して得た情報
          </p>
          <p className="sub-item">
            ⑦破産、民事再生手続開始、会社更生手続開始その他の倒産手続開始の申し立てその他の加盟店に関する信用情報
          </p>
          <p className="item">
            ２．加盟店及び代表者は、当社が、顧客に対する当社の債権を管理又は譲渡することを目的として、特別目的会社（当社が匿名組合出資持分を有する会社に限ります）、当該特別目的会社の当社以外の出資者並びに当該特別目的会社と取引する、又は取引することを検討している金融機関及びその連結対象会社（いずれも日本国以外に所在する場合を含みます）に対し、提供先の個人情報の取り扱い状況を審査のうえ、必要な範囲で前項各号に定める「加盟店取引に関する情報」を提供することに同意します。
          </p>
          <p className="item">３．本条の規定は、本契約終了後も効力を有するものとします。</p>
          <h4>第２条（加盟店情報交換センターへの登録・共同利用の同意）</h4>
          <p className="item">
            １．本契約に関して、割賦販売法等に基づく加盟店に関する情報の取扱は、次に定めるとおりとします。なお、本条各項において使用する用語は割賦販売法等の定める定義によります。
          </p>
          <p className="item">
            ２．加盟店及び加盟店の代表者は、加盟申込時の審査並びに本契約締結後の加盟店調査、加盟店に対する措置及び取引継続にかかる審査等の目的のため、当社が次の情報を収集し、利用することに同意します。
            また、当社は割賦販売法第３５条の２０及び第３５条の２１に基づいて当社が加盟する第７項の加盟店情報交換センター（ＪＤＭセンター）、並びに日本後払い決済サービス協会の自主規制ルールに基づいて当社が加盟する第７項の加盟店情報交換センター（ＢＤＭセンター）（以下、これらを総称して「センター」という）に①～⑫の情報（以下「加盟店情報」という）を報告するとともに、センターに登録されている情報がある時は第４項に定める目的の範囲内で当社及びセンターに加盟する会員会社（以下「センター加盟会員会社」という）が当該情報を共同利用します。なお、当社が現時点で加盟するセンターは第７項のとおりであり、その後、変更追加された場合、当該変更追加内容を加盟店に通知ないし当社が適当と認める方法で公表することにより、本契約におけるセンター
            として追加変更されるものとします。
          </p>
          <p className="sub-item">
            ①包括信用購入あっせん、個別信用購入あっせん取引、又は後払い決済サービス取引における、加盟店との加盟店契約締結時の調査及び苦情処理のために必要な調査の事実及び事由
          </p>
          <p className="sub-item">
            ②包括信用購入あっせん、個別信用購入あっせんにかかる業務、又は後払い決済サービス業務に関し利用者等の保護に欠ける行為をしたことを理由として包括信用購入あっせん、個別信用購入あっせんに関する契約を解除した事実及び事由
          </p>
          <p className="sub-item">
            ③クレジットカード番号等取扱契約における、加盟店によるクレジットカード番号等の適切な管理等を
            図るために必要な調査の事実及び事由
          </p>
          <p className="sub-item">
            ④クレジットカード番号等取扱契約における、加盟店によるクレジットカード番号等の適切な管理等のための措置が、
            割賦販売法に定める基準に適合せず、又は適合しないおそれがあると認めて当該加盟店に対して行った措置
            （クレジットカード番号等取扱契約の解除を含む。）の事実及び事由
          </p>
          <p className="sub-item">
            ⑤利用者又は購入者等の保護に欠ける行為に該当し、当社及び顧客に不当な損害を与える行為にかかる客観的事実に関する情報
          </p>
          <p className="sub-item">
            ⑥顧客（契約済みのものに限らない）から当社及びセンター加盟会員会社に申出のあった内容及び当該内容において利用者又は購入者等の保護に欠ける行為であると判断した情報
            （当該行為と疑われる情報及び当該行為が行われたかどうか判断することが困難な情報を含む。）
          </p>
          <p className="sub-item">
            ⑦行政機関が公表した事実とその内容（特定商取引法等について違反又は違反するおそれがあるとして、公表された情報等）について、センターが収集した情報
          </p>
          <p className="sub-item">
            ⑧センターが興信所から提供を受けた倒産情報その他公開された事実の内容
          </p>
          <p className="sub-item">⑨上記の他、利用者又は購入者等の保護に欠ける行為に関する情報</p>
          <p className="sub-item">
            ⑩前記各号にかかる包括信用購入あっせん関係販売業者又は個別信用購入あっせん関係販売業者等の氏名、住所、電話番号及び生年月日（法人の場合は、名称、住所、電話番号並びに代表者の氏名及び生年月日）
          </p>
          <p className="sub-item">
            ⑪その他当社が加盟店の加盟申込時の審査並びに本契約締結後の加盟店調査及び取引継続にかかる審査等の目的のため又は行政当局の要請等により必要と認める情報
          </p>
          <p className="sub-item">
            ⑫加盟店及び加盟店の代表者の当社とのクレジット取引等又は後払い決済サービス取引等にかかる利用の有無及び利用状況
          </p>
          <p className="item">
            ３．センター加盟会員会社は、加盟申込時の加盟店審査並びに本契約締結後の加盟店調査及び取引継続にかかる審査等の目的のため、加盟店情報を収集・利用し、センターへ登録し、センター加盟会員会社によって共同利用します。
          </p>
          <p className="item">
            ４．加盟店情報交換制度は、割賦販売法第３５条の２０及び第３５条の２１に基づき、又は日本後払い決済サービス協会の自主規制規則等に基づき、センター加盟会員会社における利用者又は購入者等の保護に欠ける行為（その疑いがある行為及び当該行為に該当するかどうか判断が困難な行為を含む。）に関する情報及び利用者等を保護するために必要な加盟店に関する情報並びに後払い決済サービスの適正な提供の障害となる加盟店の行為に関する情報、及びクレジットカード番号等の適切な管理及びクレジットカード番号等の不正な利用の防止（以
            下「クレジットカード番号等の適切な管理等」という。）に支障を及ぼす加盟店の行為に関する情報及び
            クレジットカード番号等の適切な管理等に必要な加盟店に関する情報を報告及び利用することにより、
            センター加盟会員会社の加盟店契約時又は途上の審査の精度向上を図り、悪質加盟店の排除をするとと
            もにクレジットカード番号等の適切な管理等を推進し、クレジット取引及び後払い決済サービス取引の健全な発展と消費者保護に資
            することを目的としています。
          </p>
          <p className="item">
            ５．共同利用者の範囲は以下のとおりとします。
            ①割賦販売法第３５条の２０及び第３５条の２１に基づいて一般社団法人日本クレジット協会会員であり、かつ同協会の加盟店情報交換センター（ＪＤＭセンター）加盟会員会社である包括信用購入あっせん業者、個別信用購入あっせん業者、クレジットカード番号等取扱契約締結事業者（一般社団法人日本クレジット協会のホームページ（https://www.j-credit.or.jp/）に掲載）。
            ②日本後払い決済サービス協会会員であり、かつ同協会の加盟店情報交換センター（ＢＤＭ
            センター）会員である後払い決済サービス事業者（日本後払い決済サービス協会のホームペ
            ージ（https://j-bnpla.jp/members/）に掲載）。
          </p>
          <p className="item">６．登録期間は、登録から５年を超えない期間とします。</p>
          <p className="item">７．運用責任者は次のとおりとなります。</p>
          <p>①一般社団法人日本クレジット協会加盟店情報交換センター （ＪＤＭセンター）</p>
          <p>住所：東京都中央区日本橋小網町１４－１住生日本橋小網町ビル</p>
          <p>代表理事：坂口 利彦</p>
          <p>電話番号：０３－５６４３－００１１（代表）</p>
          <p>
            ②日本後払い決済サービス協会加盟店情報交換センター（ＢＤＭセンター）
            ※後払い決済協会のウェブサイト（https://j-bnpla.jp/regulation/）をご参照ください
          </p>
          <h4>第３条（個人情報の開示・訂正・削除）</h4>
          <p className="item">
            １．加盟店及び加盟店の代表者は、当社及びセンターに対して、個人情報保護法に定めるところにより、自己に関する個人情報を開示するよう請求できるものとします。
          </p>
          <p className="item">
            ２．当社は、当社又はセンターに登録されている個人情報の内容が事実と相違していることが判明した場合には、速やかに訂正又は削除の措置をとるものとします。
          </p>
          <h4>第４条（本同意条項に不同意等の場合）</h4>
          <p>
            加盟店は、加盟申込にあたり、加盟店が記載すべき事項の記載若しくは必要な書類の提出を希望しない場合又は本同意条項の内容の全部又は一部を承諾しない場合は、当社が加盟申込の受付をお断りする
            ことがあることに同意するものとします。
          </p>

          <h4>第５条（契約不成立時及び契約終了後の加盟店情報の利用）</h4>
          <p className="item">
            １．加盟店は、契約が不成立となった場合においても、その不成立の理由の如何を問わず加盟申込をした事実、内容について当社が利用すること、及びセンターに一定期間登録され、加盟会員会社が利用する場合があることに同意するものとします。
          </p>
          <p className="item">
            ２．加盟店は、当社が契約終了後においても、業務上必要な範囲で法令等及び当社が定める所定の期間、加盟店情報を保有し利用する場合があることに同意するものとします。
          </p>

          <h4>第６条（加盟店情報に関する問合せ窓口）</h4>
          <p className="item">
            １．加盟店情報交換制度に関するお問い合わせ及び開示に関する手続については、第２条第７項に定める加盟店情報交換センターまで申し出るものとします。
          </p>
          <p className="item">
            ２．当社に対する加盟店情報に関するお問合せは、以下の当社窓口とします。
          </p>
          <p>
            【問い合わせ窓口】
            <br />
            　　　Ｐａｉｄｙ合同会社 営業本部
            <br />
            　　　〒１０７－６２１２
            <br />
            　　　東京都港区赤坂９-７-１ ミッドタウン・タワー１２階
            <br />
            　　　電話番号：０３－５５４５－５６１７
            <br />
            　　　営業時間：１０：００－１８：００（土日、祝日、年末年始を除く）
          </p>

          <h4>第７条（同意条項の位置付け及び条項の変更）</h4>
          <p className="item">１．本同意条項は当社の「加盟店規約」の一部を構成します。</p>
          <p className="item">
            2．本同意条項は加盟店に対する通知または当社が適当と認める方法で公表することにより、当社が必要な範囲内で変更できるものとします。
          </p>

          <p>2026年8月3日改定</p>
        </>
      );

      break;
    }
    case 'subscription': {
      title = '定期購入に関する特約';
      content = (
        <>
          <h4>第１条（総則）</h4>
          <p>
            本特約は、「Paidyトークン決済システム」（以下「本システム」といいます。）を利用して、顧客に対して定期購入サービス（以下「定期購入サービス」といいます。）を提供する加盟店（以下「甲」といいます。）に適用される条件について定めるものとします。なお、本特約に定めのない用語の定義または事項については、加盟店規約（以下「原規約」といいます。）の定めが適用されるものとします。
          </p>
          <h4>第２条（定期購入の申込み）</h4>
          <p>
            １．甲は、顧客から定期購入の申込みを受けたときは、Ｐａｉｄｙ合同会社（以下「乙」といいます。）所定の方法により定期購入サービスの承認を依頼するものとします。
          </p>
          <p>
            ２．乙は、第１項に基づく定期購入サービスの承認依頼を受けた場合、承認の可否を判断し、その結果を甲に通知するとともに、承認を「可」とする場合、甲に対し、定期購入サービスの利用に必要な記号（以下「トークン」といいます。）を発行するものとします。但し、顧客の乙に対する未履行の債務等がある場合等においては、乙は、その裁量により当該承認を行わないことができ、この場合、本サービスによる決済はなされないものとし、甲は予めこれを了承するものとします。
          </p>
          <p>
            ３．甲は、顧客による定期購入利用分に関しては、甲と顧客との間における売買契約等の契約成立後速やかに、乙所定の方法により信用販売の承認を依頼するものとします。
          </p>
          <p>
            ４．甲は、第２項に基づいて発行されたトークンを、本特約に基づく定期購入サービス以外の信用販売に利用してはならないものとし、また、顧客の同意なく、当該トークンを利用して申込データを作成してはならないものとします。
          </p>
          <h4>第３条（顧客による手続の省略）</h4>
          <p>
            原規約第１０条第２項の規定にかかわらず、定期購入に関する申込手続を完了した顧客の定期購入の利用については、乙は、乙所定の方法による乙所定の項目の顧客による入力を省略させることができるものとします。
          </p>
          <h4>第４条（本システムの提供の停止）</h4>
          <p>
            乙は、以下の各号のいずれかに該当する場合、本システムの提供を直ちに停止することができるものとし、この場合、乙は甲及び顧客に対し、債務不履行責任、不法行為責任、その他の法律上の原因の如何を問わず賠償の責任を負わないものとします。
          </p>
          <p>①　甲が本サービス及び本システムの利用に関して、法令、原規約又は本特約に違反したとき</p>
          <p>
            ②　本システムの不備、天災、事変、騒乱、暴動その他乙の責めに帰すことのない事由により本システムの提供がで
          </p>
          <p>きなくなったとき</p>
          <p>③　顧客から乙に対し、定期購入サービス停止の求めがあったとき</p>
          <h4>第５条（顧客との紛議）</h4>
          <p>
            １．甲は、顧客に対して販売した商品等に関する顧客との紛議（顧客に対して販売されたかどうかに関する紛議を含む。）については、遅滞なくこれを自らの責任と費用負担の下、解決するものとします。
          </p>
          <p>
            ２．甲は、別途発行する通知書に定める売上債権譲渡代金及び立替金の締切日までの間に顧客との紛議を解決することができない場合、原規約第１３条第１項に基づいて乙に対して譲渡した売上債権を直ちに同額で買い戻すものとし、又は、乙及び顧客は原規約第１４条第１項に定める立替払契約を解除し、甲はこれに同意するものとします。この場合、乙が譲り受けた当該売上債権に係る法定利息その他遅延損害金は発生しないものとし、売上債権譲渡代金又は立替金が既に支払済みの場合には、甲は、乙の請求があり次第直ちに当該金銭を返還するものとします。
          </p>

          <p>2025年11月28日改定</p>
        </>
      );

      break;
    }

    case 'token': {
      title = 'トークン利用決済サービス特約 ';
      content = (
        <>
          <h4>第１条（総則）</h4>
          <p>
            本特約は、「Paidyトークン決済システム」（以下、「本システム」といいます。）を利用して、顧客に対してトークン利用決済サービス（以下、「トークン利用決済サービス」といいます。）を提供する加盟店（以下「甲」といいます。）に適用される条件について定めるものです。なお、本特約に定めのない用語の定義または事項については、加盟店規約（以下「原規約」といいます。）の定めが適用されるものとします。
          </p>
          <h4>第２条（トークン発行の申込み）</h4>
          <p>
            １．甲は、顧客からトークン発行の申込みを受けたときは、Ｐａｉｄｙ合同会社（以下「乙」といいます。）所定の方法によりトークン発行を依頼するものとします。
          </p>
          <p>
            ２．乙は、第１項に基づくトークン発行依頼を受けた場合、トークン発行の可否を判断し、その結果を甲に通知するとともに、トークン発行を「可」とする場合、甲に対し、トークン利用決済サービスの利用に必要な記号（以下、「トークン」という。）を発行するものとします。但し、顧客の乙に対する未履行の債務等がある場合（過去に乙に対する未履行債務があった場合を含む。）等においては、乙は、その裁量によりトークン発行を行わないことができ、この場合、本サービスによる決済はなされないものとし、甲は予めこれを了承するものとします。
          </p>
          <p>
            ３．甲は、トークン利用決済サービスを利用した信用販売に関しては、甲と顧客との間における売買契約等の契約成立後速やかに、乙所定の方法により信用販売の承認を依頼するものとします。
          </p>
          <p>
            ４．甲は、第２項に基づいて発行されたトークンを、本特約に基づくトークン利用決済サービス以外の信用販売に利用してはならないものとし、また、顧客の同意なく、当該トークンを利用して申込データを作成してはならないものとします。
          </p>
          <h4>第３条（顧客による手続の省略）</h4>
          <p>
            原規約第１０条第２項の規定にかかわらず、前条第２項に基づくトークン発行手続を完了した顧客による本サービスの利用については、乙は、乙所定の方法による乙所定の項目の顧客による入力を省略させることができるものとします。
          </p>
          <h4>第４条（本システムの提供の停止）</h4>
          <p>
            乙は、以下の各号のいずれかに該当する場合、本システムの提供を直ちに停止することができるものとし、この場合、乙は甲及び顧客に対し、債務不履行責任、不法行為責任、その他の法律上の原因の如何を問わず賠償の責任を負わないものとします。
          </p>
          <p>① 甲が本サービス及び本システムの利用に関して、法令、原規約又は本特約に違反したとき</p>
          <p>
            ②
            本システムの不備、天災、事変、騒乱、暴動その他乙の責めに帰すことのない事由により本システムの提供ができなくなったとき
          </p>
          <p>③ 顧客から乙に対し、トークン利用決済サービス停止の求めがあったとき</p>
          <h4>第５条（顧客との紛議）</h4>
          <p>
            １．甲は、顧客に対して販売した商品等に関する顧客との紛議（顧客に対して販売されたかどうかに関する紛議を含む。）については、遅滞なくこれを自らの責任と費用負担の下、解決するものとします。
          </p>
          <p>
            ２．甲は、別途発行する通知書に定める売上債権譲渡代金及び立替金の締切日までの間に顧客との紛議を解決することができない場合、原規約第１３条第１項に基づいて乙に対して譲渡した売上債権を直ちに同額で買い戻すものとし、又は、乙及び顧客は原規約第１４条第１項に定める立替払契約を解除し、甲はこれに同意するものとします。この場合、乙が譲り受けた当該売上債権に係る法定利息その他遅延損害金は発生しないものとし、売上債権譲渡代金又は立替金が既に支払済みの場合には、甲は、乙の請求があり次第直ちに当該金銭を返還するものとします。
          </p>

          <p>2025年11月28日改定</p>
        </>
      );

      break;
    }
    default:
      break;
  }

  return (
    <>
      <h3>{title}</h3>
      <div className="modal-content">{content}</div>
    </>
  );
};

const Modal = ({ _updateUIPairs, modalType }: { _updateUIPairs: Function, modalType: string }) => {
  const onClose = () => {
    _updateUIPairs({ showModal: false });
  };

  return (
    <div className="overlay">
      <div className="modal">
        <article>
          <Content modalType={modalType} />
        </article>
        <button onClick={onClose} className="btn-close-modal">
          戻る
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modalType: state.ui.modalType,
});

const mapDispatchToProps = (dispatch: Function) => ({
  _updateUIPairs: (pairs) => dispatch(updateUIPairs(pairs)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
